// extracted by mini-css-extract-plugin
export default {"page_wrapper":"ContactPage_page_wrapper__MrJqv","main":"ContactPage_main__L6CYJ"};